import React, { FC, Fragment } from 'react';
import { Alert, Snackbar, Link, AlertTitle, IconButton, LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

type DeliveryNoteSnackbarProps = {
    open: boolean;
    message?: string;
    title?: string;
    type: 'success' | 'info' | 'warning' | 'error' | undefined;
    spinner: boolean;
    signedUrl: string | null;
    onClose: () => void;
};
const DeliveryNoteSnackbar: FC<DeliveryNoteSnackbarProps> = ({
    open,
    title,
    type,
    message,
    spinner,
    signedUrl,
    onClose,
}: DeliveryNoteSnackbarProps) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    const handleSignedUrlDownload = (signedUrl: string) => {
        window.open(signedUrl);
        onClose();
    };

    return (
        <Snackbar open={open} onClose={onClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Alert
                onClose={onClose}
                variant="filled"
                severity={type}
                sx={{ minWidth: 320, boxShadow: 4 }}
                action={
                    <Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Fragment>
                }
            >
                {title ? <AlertTitle>{title}</AlertTitle> : undefined}
                {message ? message : undefined}
                {spinner ? <LinearProgress /> : undefined}
                {signedUrl ? (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => handleSignedUrlDownload(signedUrl)}
                        color="#fff"
                    >
                        {translate('common:DOWNLOAD')}
                    </Link>
                ) : undefined}
            </Alert>
        </Snackbar>
    );
};

export default DeliveryNoteSnackbar;
